class WilcoShippingEstimator {
  constructor(container) {
    this.container = container;

    this.form = container.querySelector('[data-shipping-form]');
    this.zipInput = container.querySelector('[data-shipping-zip]');
    this.stateInput = container.querySelector('[data-shipping-state]');
    this.button = container.querySelector('[data-shipping-submit]');
    this.results = container.querySelector('[data-shipping-results]');
    this.message = container.querySelector('[data-shipping-message]');

    this.cart = null;
    this.rates = [];
    this.selectedRate = null;

    if (
      !this.form ||
      !this.zipInput ||
      !this.stateInput ||
      !this.button
    ) {
      return;
    }

    const savedZip =
      localStorage.getItem('wilco_shipping_zip');

    const savedState =
      localStorage.getItem('wilco_shipping_state');

    if (savedZip) {
      this.zipInput.value = savedZip;
    }

    if (savedState) {
      this.stateInput.value = savedState;
    }

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.calculate();
    });
  }

  getRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  buildParams(zip, state) {
    const params = new URLSearchParams();

    params.set('shipping_address[zip]', zip);
    params.set('shipping_address[province]', state);
    params.set(
      'shipping_address[country]',
      'United States'
    );

    return params;
  }

  async getCart() {
    const response = await fetch(
      this.getRoot() + 'cart.js',
      {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        `Could not load cart: ${response.status}`
      );
    }

    return response.json();
  }
  getStateFromZip(zip) {
  const prefix = parseInt(zip.substring(0, 3), 10);

  const ranges = [
    ['NY', 5, 149],
    ['PA', 150, 196],
    ['DE', 197, 199],
    ['DC', 200, 205],
    ['VA', 201, 246],
    ['WV', 247, 268],
    ['NC', 270, 289],
    ['SC', 290, 299],
    ['GA', 300, 319],
    ['FL', 320, 349],
    ['AL', 350, 369],
    ['TN', 370, 385],
    ['MS', 386, 397],
    ['KY', 400, 427],
    ['OH', 430, 459],
    ['IN', 460, 479],
    ['MI', 480, 499],
    ['IA', 500, 528],
    ['WI', 530, 549],
    ['MN', 550, 567],
    ['SD', 570, 577],
    ['ND', 580, 588],
    ['MT', 590, 599],
    ['IL', 600, 629],
    ['MO', 630, 658],
    ['KS', 660, 679],
    ['NE', 680, 693],
    ['LA', 700, 714],
    ['AR', 716, 729],
    ['OK', 730, 749],
    ['TX', 750, 799],
    ['CO', 800, 816],
    ['WY', 820, 831],
    ['ID', 832, 838],
    ['UT', 840, 847],
    ['AZ', 850, 865],
    ['NM', 870, 884],
    ['NV', 889, 898],
    ['CA', 900, 961],
    ['HI', 967, 968],
    ['OR', 970, 979],
    ['WA', 980, 994],
    ['AK', 995, 999]
  ];

  /*
   * Several states have overlapping/non-contiguous
   * ZIP-prefix areas, so handle those separately.
   */

  if (prefix >= 10 && prefix <= 27) return 'MA';
  if (prefix >= 28 && prefix <= 29) return 'RI';
  if (prefix >= 30 && prefix <= 38) return 'NH';
  if (prefix >= 39 && prefix <= 49) return 'ME';
  if (prefix >= 50 && prefix <= 59) return 'VT';
  if (prefix >= 60 && prefix <= 69) return 'CT';
  if (prefix >= 70 && prefix <= 89) return 'NJ';

  for (const [state, min, max] of ranges) {
    if (prefix >= min && prefix <= max) {
      return state;
    }
  }

  return null;
}

  async calculate() {
    const zip = this.zipInput.value.trim();

let state = this.getStateFromZip(zip);

if (!state) {
  state = this.stateInput.value;
}

    if (!/^\d{5}(-\d{4})?$/.test(zip)) {
      this.showError(
        'Please enter a valid U.S. ZIP code.'
      );
      return;
    }

    if (!state) {
  this.showError(
    'We could not determine the state for this ZIP code. Please select your state.'
  );

  this.stateInput
    .closest('.wilco-shipping__field')
    ?.classList.add('wilco-shipping__field--state-visible');

  return;
}
this.stateInput.value = state;

    localStorage.setItem(
      'wilco_shipping_zip',
      zip
    );

    localStorage.setItem(
      'wilco_shipping_state',
      state
    );

    this.setLoading(true);

    this.results.innerHTML = '';
    this.message.textContent = '';

    try {
      /*
       * Load the current Shopify cart first.
       * This gives us the real discounted
       * cart total in the customer's currency.
       */
      this.cart = await this.getCart();

      const params =
        this.buildParams(zip, state);

      const prepareURL =
        this.getRoot() +
        'cart/prepare_shipping_rates.json?' +
        params.toString();

      const prepareResponse =
        await fetch(prepareURL, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

      if (!prepareResponse.ok) {
        const errorText =
          await prepareResponse.text();

        console.error(
          'Prepare shipping rates failed:',
          prepareResponse.status,
          errorText
        );

        throw new Error(
          `Shopify returned ${prepareResponse.status}: ${errorText}`
        );
      }

      const rates =
        await this.pollRates(params);

      this.rates = rates;

      /*
       * Use the first Shopify shipping rate
       * as the default selection.
       */
      this.selectedRate =
        rates && rates.length
          ? rates[0]
          : null;

      this.renderRates(
        rates,
        zip,
        state
      );

    } catch (error) {
      console.error(
        'Wilco Shipping Estimator Error:',
        error
      );

      this.showError(
        'Shipping could not be calculated. Please try again.'
      );
    } finally {
      this.setLoading(false);
    }
  }

  async pollRates(params) {
    const maxAttempts = 20;

    for (
      let attempt = 0;
      attempt < maxAttempts;
      attempt++
    ) {
      const url =
        this.getRoot() +
        'cart/async_shipping_rates.json?' +
        params.toString();

      const response =
        await fetch(url, {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

      if (!response.ok) {
        const errorText =
          await response.text();

        throw new Error(
          `Shopify returned ${response.status}: ${errorText}`
        );
      }

      const data =
        await response.json();

      if (
        data &&
        Array.isArray(data.shipping_rates)
      ) {
        return data.shipping_rates;
      }

      await new Promise(
        resolve =>
          setTimeout(resolve, 500)
      );
    }

    throw new Error(
      'Shopify shipping calculation timed out.'
    );
  }

  renderRates(rates, zip, state) {
    this.results.innerHTML = '';

    if (!rates || rates.length === 0) {
      this.showError(
        `No shipping options are available for ${zip}.`
      );

      return;
    }

    const destination =
      document.createElement('div');

    destination.className =
      'wilco-shipping__destination';

    destination.innerHTML = `
      <span>Shipping to</span>
      <strong>${zip}, ${state}</strong>
    `;

    const list =
      document.createElement('div');

    list.className =
      'wilco-shipping__rates';

    rates.forEach((rate, index) => {
      const label =
        document.createElement('label');

      label.className =
        'wilco-shipping__rate wilco-shipping__rate--selectable';

      const radio =
        document.createElement('input');

      radio.type = 'radio';
      radio.name = 'wilco-shipping-rate';
      radio.value = index;
      radio.className =
        'wilco-shipping__rate-radio';

      if (index === 0) {
        radio.checked = true;
      }

      const info =
        document.createElement('div');

      info.className =
        'wilco-shipping__rate-info';

      const name =
        document.createElement('span');

      name.className =
        'wilco-shipping__rate-name';

      name.textContent =
        rate.presentment_name ||
        rate.name ||
        'Shipping';

      info.appendChild(name);

      const deliveryText =
        this.getDeliveryEstimate(rate);

      if (deliveryText) {
        const delivery =
          document.createElement('span');

        delivery.className =
          'wilco-shipping__delivery';

        delivery.textContent =
          deliveryText;

        info.appendChild(delivery);
      }

      const price =
        document.createElement('strong');

      price.className =
        'wilco-shipping__rate-price';

      price.textContent =
        this.formatMoneyFromDollars(
          this.getRatePrice(rate),
          rate.currency ||
            this.cart?.currency ||
            'USD'
        );

      radio.addEventListener(
        'change',
        () => {
          this.selectedRate = rate;

          this.renderSummary();
        }
      );

      label.appendChild(radio);
      label.appendChild(info);
      label.appendChild(price);

      list.appendChild(label);
    });

    const summary =
      document.createElement('div');

    summary.className =
      'wilco-shipping__summary';

    summary.setAttribute(
      'data-shipping-summary',
      ''
    );

    this.results.appendChild(
      destination
    );

    this.results.appendChild(list);

    this.results.appendChild(summary);

    this.renderSummary();
  }

  renderSummary() {
    const summary =
      this.container.querySelector(
        '[data-shipping-summary]'
      );

    if (
      !summary ||
      !this.cart ||
      !this.selectedRate
    ) {
      return;
    }

    /*
     * Shopify Ajax cart money values are
     * integer minor units (cents for USD).
     */
    const subtotalCents =
      Number(this.cart.total_price || 0);

    const shippingDollars =
      this.getRatePrice(
        this.selectedRate
      );

    const shippingCents =
      Math.round(
        shippingDollars * 100
      );

    const estimatedTotalCents =
      subtotalCents + shippingCents;

    const currency =
      this.cart.currency || 'USD';

    summary.innerHTML = `
      <div class="wilco-shipping__summary-row">
        <span>Subtotal</span>
        <span>
          ${this.formatMoneyFromCents(
            subtotalCents,
            currency
          )}
        </span>
      </div>

      <div class="wilco-shipping__summary-row">
        <span>Shipping</span>
        <span>
          ${this.formatMoneyFromCents(
            shippingCents,
            currency
          )}
        </span>
      </div>

      <div class="wilco-shipping__summary-divider"></div>

      <div class="wilco-shipping__summary-row wilco-shipping__summary-total">
        <strong>
          Estimated Total Before Tax
        </strong>

        <strong>
          ${this.formatMoneyFromCents(
            estimatedTotalCents,
            currency
          )}
        </strong>
      </div>

      <p class="wilco-shipping__tax-note">
        Tax calculated at checkout.
      </p>
    `;
  }

  getRatePrice(rate) {
    const price =
      parseFloat(rate?.price || 0);

    return Number.isFinite(price)
      ? price
      : 0;
  }

  formatMoneyFromDollars(
    amount,
    currency = 'USD'
  ) {
    return new Intl.NumberFormat(
      'en-US',
      {
        style: 'currency',
        currency
      }
    ).format(amount);
  }

  formatMoneyFromCents(
    amount,
    currency = 'USD'
  ) {
    return new Intl.NumberFormat(
      'en-US',
      {
        style: 'currency',
        currency
      }
    ).format(amount / 100);
  }

  getDeliveryEstimate(rate) {
    /*
     * Prefer a delivery range supplied
     * directly by Shopify/carrier.
     *
     * Shopify can return delivery_range
     * as an array.
     */
    if (
      Array.isArray(
        rate.delivery_range
      ) &&
      rate.delivery_range.length >= 2
    ) {
      return (
        'Estimated delivery: ' +
        this.formatDeliveryDate(
          rate.delivery_range[0]
        ) +
        ' – ' +
        this.formatDeliveryDate(
          rate.delivery_range[1]
        )
      );
    }

    if (rate.delivery_date) {
      return (
        'Estimated delivery: ' +
        this.formatDeliveryDate(
          rate.delivery_date
        )
      );
    }

    return this.getFallbackDeliveryWindow(
      rate
    );
  }

  formatDeliveryDate(value) {
    const date =
      value instanceof Date
        ? value
        : new Date(
            `${value}T12:00:00`
          );

    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return value;
    }

    return date.toLocaleDateString(
      'en-US',
      {
        month: 'short',
        day: 'numeric'
      }
    );
  }

  getFallbackDeliveryWindow(rate) {
    const name = (
      rate.presentment_name ||
      rate.name ||
      ''
    ).toLowerCase();

    let minTransit = 3;
    let maxTransit = 7;

    if (
      name.includes('next day') ||
      name.includes('overnight')
    ) {
      minTransit = 1;
      maxTransit = 1;

    } else if (
      name.includes('2nd day') ||
      name.includes('2-day') ||
      name.includes('2 day')
    ) {
      minTransit = 2;
      maxTransit = 2;

    } else if (
      name.includes('3 day') ||
      name.includes('3-day')
    ) {
      minTransit = 3;
      maxTransit = 3;

    } else if (
      name.includes('ground') ||
      name.includes('standard')
    ) {
      minTransit = 3;
      maxTransit = 7;
    }

    /*
     * Wilco processing time:
     * 1–2 business days.
     */
    const handlingMin = 1;
    const handlingMax = 2;

    const earliest =
      this.addBusinessDays(
        new Date(),
        handlingMin + minTransit
      );

    const latest =
      this.addBusinessDays(
        new Date(),
        handlingMax + maxTransit
      );

    return (
      'Estimated delivery: ' +
      this.formatDeliveryDate(
        earliest
      ) +
      ' – ' +
      this.formatDeliveryDate(
        latest
      )
    );
  }

  addBusinessDays(date, days) {
    const result =
      new Date(date);

    let added = 0;

    while (added < days) {
      result.setDate(
        result.getDate() + 1
      );

      const day =
        result.getDay();

      if (
        day !== 0 &&
        day !== 6
      ) {
        added++;
      }
    }

    return result;
  }

  setLoading(loading) {
    this.button.disabled =
      loading;

    this.button.textContent =
      loading
        ? 'CALCULATING...'
        : 'ESTIMATE';
  }

  showError(message) {
    this.results.innerHTML = '';

    this.message.textContent =
      message;
  }
}

function initializeWilcoShippingEstimators(root = document) {
  const containers = [];

  if (
    root instanceof Element &&
    root.matches('[data-wilco-shipping-estimator]')
  ) {
    containers.push(root);
  }

  if (root.querySelectorAll) {
    containers.push(
      ...root.querySelectorAll(
        '[data-wilco-shipping-estimator]'
      )
    );
  }

  containers.forEach(container => {
    if (container.dataset.initialized === 'true') {
      return;
    }

    container.dataset.initialized = 'true';

    new WilcoShippingEstimator(container);
  });
}


/*
 * Initial page load
 */
if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => initializeWilcoShippingEstimators()
  );
} else {
  initializeWilcoShippingEstimators();
}


/*
 * Shopify Theme Editor
 */
document.addEventListener(
  'shopify:section:load',
  event => {
    initializeWilcoShippingEstimators(
      event.target
    );
  }
);


/*
 * Dawn replaces portions of the cart drawer
 * whenever an item is added/updated.
 *
 * Watch ONLY the cart drawer rather than the
 * entire document.
 */
function observeWilcoCartDrawer() {
  const drawer =
    document.querySelector('cart-drawer');

  if (!drawer) {
    return;
  }

  if (drawer.dataset.wilcoObserver === 'true') {
    return;
  }

  drawer.dataset.wilcoObserver = 'true';

  const observer =
    new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof Element)) {
            return;
          }

          initializeWilcoShippingEstimators(node);
        });
      });
    });

  observer.observe(drawer, {
    childList: true,
    subtree: true
  });
}


if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    observeWilcoCartDrawer
  );
} else {
  observeWilcoCartDrawer();
}